/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Email {
    export class EmailController {

        private emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        private email: string;
        private userName: string;
        private isValid = true;

        static $inject = [
            "$mdDialog",
            "meevo.components.common.IdentityService",
            "meevo.components.common.DataService",
            "$translate"
        ];

        constructor(
            private $mdDialog: angular.material.IDialogService,
            private identityService: Meevo.Components.Common.IdentityService,
            private dataService: Meevo.Components.Common.ICommonDataService,
            private $translate: angular.translate.ITranslateService) {

            this.userName = this.identityService.current().userAuthName;

        }

        submit() {
            const url = `/api/employee/email`
            const account = {
                userId: this.identityService.current().userAuthId,
                tenantId: this.identityService.current().tenantId,
                email: this.email
            }
            this.dataService.customMethodData(url, 'POST', account)
                .then(res => {
                    if (res.data) {
                        this.cancel();
                    } else {
                        this.isValid = res.data;
                        setTimeout(() => {
                            this.email = null;
                            this.isValid = true
                        }, 500)
                    }
                })
                .catch(err => {
                    console.debug('Email Update Error', err);
                    this.cancel();
                })

        }

        cancel() {
            return this.$mdDialog.hide(false);
        }


    }

angular.module("meevo")
    .controller("meevo.email.EmailController", EmailController);
}